export default __webpack_public_path__ + "static/media/strRev.a41dfeb8.jpg";